module.exports = __webpack_public_path__ + "media/application/images/cyber-forum/last-year-bg@2x-1bf4db088e7de368f8baaeb162b87910.jpg";